enum PhaseOfPlay {
  ATTACKING = "ATTACKING",
  BUILD_UP = "BUILD_UP",
  COUNTER_ATTACK = "COUNTER_ATTACK",
}

export default PhaseOfPlay;
